import React, { createContext, useState, useEffect } from "react";

const ApiContext = createContext();

const Context = ({ children }) => {
  const [logindata, setlogindata] = useState({});
  const [userData, setuserData] = useState({});
  const [coordinates, setcoordinates] = useState(null);
  const [address, setaddress] = useState("");

  const [CityData, setCityData] = useState([]);
  const [Locality, setLocality] = useState([]);
  const [Area, setArea] = useState([]);
  const [Projects, setProjects] = useState([]);

  const [vertical, setVertical] = useState([]);

  const [properType, setproperType] = useState([]);

  // const [chooseProperty, setchooseProperty] = useState([]);
  const [searchData, setsearchData] = useState([]);
  const [BHKData, setBHKData] = useState([]);

  const [FurnishType, setFurnishType] = useState([]);
  const [societyAmenities, setSocietyAmenities] = useState([]);
  const [constructionStatus, setConstructionStatus] = useState([]);
  const [propertyAmenities, setPropertyAmenities] = useState([]);
  const [roomConfig, setRoomConfig] = useState([]);
  const [Meals, setMeals] = useState([]);
  const [CommonArea, setCommonArea] = useState([]);
    const [PGisFor, setPGisFor] = useState([
      {
        id: 1,
        name: "Boys",
        colorCode: "#000000",
      },
      {
        id: 2,
        name: "Girls",
        colorCode: "#000000",
      },
    ]);
  
    const [bestSuitFor, setBestSuitFor] = useState([
      {
        id: 1,
        name: "Students",
        colorCode: "#000000",
      },
      {
        id: 2,
        name: "Professionals",
        colorCode: "#000000",
      },
    ]);


  // selected variables can be added here as needed


    const [selected_vertical, setSelectedVertical] = useState([]);

  const [selected_properType, setSelectedProperType] = useState([]);


  const [selected_BHKData, setSelectedBHKData] = useState([]);

    const [selected_FurnishType, setSelectedFurnishType] = useState([]);
    const [selected_societyAmenities, setSelectedSocietyAmenities] = useState([]);
    const [selected_constructionStatus, setSelectedConstructionStatus] = useState([]);
    const [selected_propertyAmenities, setSelectedPropertyAmenities] = useState([]);
    const [selected_roomConfig, setSelectedRoomConfig] = useState([]);
    const [selected_Meals, setSelectedMeals] = useState([]);
    const [selected_CommonArea, setSelectedCommonArea] = useState([]);

    const [selected_PGisFor, setSelectedPGisFor] = useState([]);
  const [selected_bestSuitFor, setSelectedBestSuitFor] = useState([]);
  const [wishlist, setWishlist] = useState(  []);

 
  return (
    <ApiContext.Provider
      value={{
        logindata,
        setlogindata,
        coordinates,
        setcoordinates,
        address,
        setaddress,
        userData,
        setuserData,
        CityData,
        setCityData,
        vertical,
        setVertical,
        properType,
        setproperType,

        BHKData,
        setBHKData,
        Locality,
        setLocality,
        Area,
        setArea,
        Projects,
        setProjects,
        searchData,
        setsearchData,
        FurnishType,
        setFurnishType,
        societyAmenities,
        setSocietyAmenities,
        constructionStatus,
        setConstructionStatus,
        propertyAmenities,
        setPropertyAmenities,
        roomConfig,
        setRoomConfig,
        Meals,
        setMeals,
        CommonArea,
        setCommonArea,
        PGisFor,
        setPGisFor,
        bestSuitFor,
        setBestSuitFor,
        selected_FurnishType,
        setSelectedFurnishType,
        selected_societyAmenities,
        setSelectedSocietyAmenities,
        selected_constructionStatus,
        setSelectedConstructionStatus,
        selected_propertyAmenities,
        setSelectedPropertyAmenities,
        selected_roomConfig,
        setSelectedRoomConfig,
        selected_Meals,
        setSelectedMeals,
        selected_CommonArea,  
        setSelectedCommonArea,
        selected_PGisFor,
        setSelectedPGisFor,
        selected_bestSuitFor,
        setSelectedBestSuitFor,

        selected_vertical,
        setSelectedVertical,
        selected_properType,
        setSelectedProperType,
        selected_BHKData,
        setSelectedBHKData,wishlist, setWishlist

      }}
    >
      {children}
    </ApiContext.Provider>
  );
};

export { ApiContext, Context };
